// The browser-side state of a case walk: funnel position, finished stages,
// the persisted scan verdict, per-feature wizard state. Wiped by "Delete
// everything and start over" and by the demo seeder before it writes a
// fresh persona. The auth session, the demo flag and the post-sign-in
// return URL are deliberately NOT flow state.

const FLOW_KEYS = new Set([
  "conv-step",
  "sp-done",
  "vg_lead",
  "vg-paid",
  "vg-outcome",
  "attorney-fork-seen",
  "attorney-call-booked",
]);
const FLOW_PREFIXES = ["sp-", "i140-", "ls-", "ev-"];

export function isFlowKey(k: string): boolean {
  return FLOW_KEYS.has(k) || FLOW_PREFIXES.some((p) => k.startsWith(p));
}

function wipe(store: Storage): void {
  const keys: string[] = [];
  for (let i = 0; i < store.length; i++) {
    const k = store.key(i);
    if (k && isFlowKey(k)) keys.push(k);
  }
  keys.forEach((k) => store.removeItem(k));
}

/** Remove every flow-state key from localStorage and sessionStorage. */
export function wipeFlowState(): void {
  try {
    wipe(localStorage);
  } catch {
    /* private mode */
  }
  try {
    wipe(sessionStorage);
  } catch {
    /* private mode */
  }
}
